export default function(h) {
  return h('canvas')
}
